import { render, staticRenderFns } from "./OngletSyntheseTechnique.vue?vue&type=template&id=0a0bd687"
import script from "./OngletSyntheseTechnique.vue?vue&type=script&lang=js"
export * from "./OngletSyntheseTechnique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports